import { Skeleton } from '@/design-system';
import { ns, useT } from '@/i18n';

/** Shown while a page's code loads. Same rhythm as a page header, so nothing jumps. */
export function PageFallback() {
  const t = useT(ns.common);
  return (
    <div className="l-wrap" aria-busy="true" aria-label={t('loading')}>
      <div style={{ padding: '34px 0 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <Skeleton width={180} height={14} />
        <Skeleton width="min(520px, 80%)" height={48} radius={14} />
      </div>
      <Skeleton height={320} radius={28} />
    </div>
  );
}
